export function fileSize(value) {
  if (+value) {
    return `${(+value / 1024).toFixed(2)} KB`
  }

  return ''
}
